import React, { FC, useCallback, useEffect } from "react";
import { useDevicePermissionsStore } from "../../storez/DevicePermissionsStore";
import { useSessionStore } from "../../storez/SessionStore";

const ForethoughtAI: FC = () => {
  const [permissionsLoaded, permissions] = useDevicePermissionsStore(
    useCallback((state) => [state.loaded, state.permissions] as const, [])
  );

  const [device, user] = useSessionStore(useCallback((state) => [state.getDevice(), state.getUser()] as const, []));

  const removeForethoughtAIChatbot = () => {
    document.getElementById("forethought-chat")?.remove();
    document.getElementById("forethought-widget-embed-script")?.remove();
  };

  const getLocale = (region: string, timezone: string): string => {
    switch (region) {
      case "us-1":
        if (timezone.includes("Pacific")) {
          return "en-NZ";
        }
        return "en-US";
      case "syd-2":
        return "en-AU";
      case "uk-1":
        return "en-GB";
      default:
        return "en-US";
    }
  };

  useEffect(() => {
    if (!process.env.REACT_APP_FORETHOUGHT_AI_API_KEY) return;

    if (!device || !user) {
      removeForethoughtAIChatbot();
      return;
    }

    if (!permissionsLoaded) return;

    // The following script is available in the ForethoughtAI dashboard
    // ForethoughtAI app link: https://qoria.forethought.app/
    document.querySelector("#forethought-chat")?.remove();
    const script = document.createElement("script");
    script.setAttribute("src", "https://solve-widget.forethought.ai/embed.js");
    script.setAttribute("id", "forethought-widget-embed-script");
    script.setAttribute("data-api-key", process.env.REACT_APP_FORETHOUGHT_AI_API_KEY);
    script.setAttribute("data-ft-Device-Id", device.id || "");
    script.setAttribute("data-ft-Email", user.username || "");
    // script.setAttribute("data-ft-Full-Name", ""); // SM does not have access to the user's full name.
    script.setAttribute("data-ft-Locale", getLocale(device.region, device.timezone));
    script.setAttribute("data-ft-workflow-tag", "SchoolManager");
    script.setAttribute("data-ft-user-permissions", permissions.join(","));
    document.head.append(script);

    return () => {
      removeForethoughtAIChatbot();
    };
  }, [device, user, permissionsLoaded, permissions]);

  return <div id="forethoughtAIChatbot"></div>;
};

export default ForethoughtAI;
